var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#008CE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 13.5547H19.1211L18.2617 18.3203L27.5391 18.3398C32.1094 18.3398 33.457 20 33.418 22.7539C33.3984 24.1602 32.793 26.5625 32.5195 27.3242C31.8164 29.3945 30.3711 31.7383 24.9414 31.7383H15.918L15.0977 36.5234H25.3711C28.9844 36.5234 30.5273 36.0938 32.168 35.3516C35.7812 33.6719 37.9297 30.1172 38.7891 25.4492C40.0586 18.4961 38.457 13.5547 29.4141 13.5547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6289 22.7148C11.9336 22.7148 11.543 24.4922 11.2891 25.5664C10.957 26.9727 10.8398 27.5391 10.8398 27.5391H21.4062C24.1016 27.5391 24.4922 25.7617 24.7461 24.6875C25.0781 23.2812 25.1953 22.7148 25.1953 22.7148H14.6289Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20);
export default __webpack_public_path__ + "static/media/20.bae05823c261ab508d6069cf9d6a4e85.svg";
export { ForwardRef as ReactComponent };